import { useLatestEntity, useThunkDispatch } from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

import * as publicationInspectionActions from '@redux/modules/publicationInspection'
import type { AppDispatch } from '@redux/store'

import type { PublicationInspectionModel } from '@models/types'

export const generateUrls = () => ({ inspectionsUrl: '#/newsDesk/inspections' })

export type SendPublicationInspectionsAlertParams = {
  agency_id: number,
  edition_id: number,
}

type SendPublicationInspectionsAlert = {
  dispatch: AppDispatch,
  sendAlertParams: SendPublicationInspectionsAlertParams,
}

const sendPublicationInspectionsAlert = (params: SendPublicationInspectionsAlert) => {
  const { sendAlertParams, dispatch } = params
  const { sendPublicationInspectionsAlert: sendAlert } = publicationInspectionActions

  return dispatch(sendAlert(sendAlertParams))
}

function usePublicationInspection(initEntity: Partial<PublicationInspectionModel> = {}) {
  // @ts-expect-error TS2322
  const { entity: publicationInspection }:
  { entity: PublicationInspectionModel} = useLatestEntity(initEntity, 'publicationInspections')

  const dispatch = useThunkDispatch()

  const { loading } = useSelector(reduxState => reduxState.orders)

  return {
    callbacks: {
      sendPublicationInspectionsAlert: (
        sendAlertParams: SendPublicationInspectionsAlertParams,
      ) => sendPublicationInspectionsAlert({ sendAlertParams, dispatch }),
    },
    loading,
    publicationInspection,
    urls: generateUrls(),
  }
}

export default usePublicationInspection
